import React from "react";
import { Controller } from "react-hook-form";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";
import ErrorMessage from "../error-message";
import CurrencyInput from "./CurrencyInput";
import useFieldDisabler from "utils/custom-hooks/useFieldDisabler";

interface Props {
  label?: string;
  name: any;
  type?: string;
  defaultValue?: any;
  inputProps?: any;
  isError?: boolean;
  disabled?: boolean;
  allowNegative?: boolean;
  maxLength?: number;
  maxNumberOfDigits?: number;
  useFormProvider?: boolean;
  onChange?: any;
  onBlur?: (value: string | null) => void;
  placeholder ? : string ;
  showOutsideError?: boolean;
  showZero ?:boolean;
}

const CurrencyInputField = ({
  label,
  name,
  type,
  disabled,
  allowNegative,
  maxLength,
  maxNumberOfDigits,
  defaultValue,
  onBlur,
  onChange,
  placeholder,
  showOutsideError =true,
  showZero,
}: Props) => {
  const { control, setValue } = useFormWrapper();
  const shouldFieldBeDisabled = useFieldDisabler(name);

  const handleOnBlur = (value: string, onBlurForm: any) => {
    onBlurForm();
    onBlur && onBlur(value);
  };

  const handleOnChange = (e: any, val: number | string) => {
    const valueOrDefault = val !== "" ? val : 0;
    setValue(name, valueOrDefault);
    onChange && onChange(e, val);
  };

  return (
    <>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({ field: { name, value, onBlur, ref }, fieldState }) => {
          let cleanedValue = value;
          if (typeof value === "string")
            cleanedValue = (value as string).replace("$", "");
          return (
            <CurrencyInput
              ref={ref}
              hasError={Boolean(fieldState.error)}
              name={name}
              label={label}
              type={type}
              value={cleanedValue}
              onChange={handleOnChange}
              onBlur={(value: string) => handleOnBlur(value, onBlur)}
              disabled={disabled || shouldFieldBeDisabled}
              allowNegative={allowNegative}
              maxLength={maxLength}
              maxNumberOfDigits={maxNumberOfDigits}
              placeholder={placeholder}
              showOutsideError ={showOutsideError}
              showZero={showZero}
            />
          );
        }}
      />
      { showOutsideError && <ErrorMessage name={name} />}
    </>
  );
};

export default CurrencyInputField;
